"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.updateGigDetails = updateGigDetails;
const baseUrls_1 = require("./baseUrls");
const fetchWrapper_1 = require("./fetchWrapper");
async function updateGigDetails(formValues, authHeader, gigId) {
    return (0, fetchWrapper_1.fetchWrapper)(`${baseUrls_1.GigsApiBaseUrl}/updateGigDetails?gigId=${gigId}`, {
        method: 'PATCH',
        headers: {
            Authorization: authHeader,
        },
        body: formValues,
    });
}
